import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Drawer from "react-motion-drawer";
import { Menu, Dropdown, Layout, Button, Col, Row, Icon } from "antd";

import UserContext from "../../Contexts/UserContext";
import ItemMenu from "./ItemMenu";

import asXpertLogo from "../../img/AS Xpert logo web.png";
import DrawerMenu from "./DrawerMenu";

const { Header } = Layout;

const menu = (profile, signOut) => {
  const { name, email } = profile.attributes;
  return (
    <Menu
      style={{
        padding: "1rem 0",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Menu.Item>
        <ItemMenu
          icon="user"
          pathname="/profile"
          isDrawer={false}
          content={
            <React.Fragment>
              <span style={{ fontWeight: "bold" }}>{name}</span>
              <span>{email}</span>
            </React.Fragment>
          }
        />
      </Menu.Item>
      <Menu.Item>
        <ItemMenu
          icon="solution"
          pathname="/orders"
          isDrawer={false}
          content={
            <React.Fragment>
              <span style={{ fontWeight: "bold" }}>Historial de Pedidos</span>
            </React.Fragment>
          }
        />
      </Menu.Item>
      <Menu.Item>
        <a style={{ display: "flex", alignItems: "center" }} onClick={signOut}>
          <Icon type="logout" style={{ fontSize: "2.5rem" }} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "0 2rem",
              fontWeight: "bold"
            }}
          >
            Salir
          </div>
        </a>
      </Menu.Item>
    </Menu>
  );
};

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerVisible: false
    };
    this.handleStateDrawer = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps !== this.props || nextState !== this.state;
  }

  getDefaultKey = pathname => {
    const pathSnippets = pathname.split("/").filter(i => i);
    switch (pathSnippets[0]) {
      case undefined:
        return ["1"];
      case "orders":
        return ["2"];
      default:
        break;
    }
  };

  selectedDrawerItem() {
    this.setState({ drawerVisible: false });
  }

  handleDrawer() {
    if (this.handleStateDrawer) {
      this.setState({ drawerVisible: false });
    }
    this.handleStateDrawer = !this.handleStateDrawer;
    if (!this.state.drawerVisible) {
      this.handleStateDrawer = false;
    }
  }

  onSelectKey = ({ item, key, selectedKeys }) => {
    const { history } = this.props;
    switch (key) {
      case "1":
        history.push("/");
        break;
      case "2":
        history.push("/orders");
        break;
      default:
        break;
    }
  };

  render() {
    const {
      location: { pathname }
    } = this.props;
    return (
      <UserContext.Consumer>
        {({ signedIn, signOut, profile }) => {
          const names = profile && profile.attributes.name.split(" ");
          return (
            <Header className="header">
              <Row type="flex" justify="center" style={{ flex: 1 }}>
                <div
                  style={{
                    width: "21rem",
                    position: "absolute",
                    left: 0,
                    zIndex: -1
                  }}
                >
                  <img
                    height={58}
                    src={asXpertLogo}
                    alt="asxpert-logo"
                    className="logo_image"
                  />
                </div>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                  xl={{ span: 22 }}
                  xxl={{ span: 18 }}
                >
                  <div className="container_tabbar">
                    <div className="container_menu">
                      <Menu
                        theme="dark"
                        mode="horizontal"
                        defaultSelectedKeys={["2"]}
                        style={{
                          lineHeight: "64px",
                          backgroundColor: "var(--color-primary-blue-dark)",
                          borderBottom: 0,
                          marginRight: "5rem"
                        }}
                        selectedKeys={this.getDefaultKey(pathname)}
                        onSelect={this.onSelectKey}
                      >
                        <Menu.Item key="1">Inicio</Menu.Item>
                        <Menu.Item key="2">Órdenes</Menu.Item>
                      </Menu>
                    </div>
                    <Dropdown
                      overlay={menu(profile, signOut)}
                      placement="bottomRight"
                    >
                      <Button
                        style={{
                          height: "5rem",
                          width: "5rem",
                          borderRadius: "5rem",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "1rem",
                          alignItems: "center",
                          backgroundColor: "transparent",
                          color: "white"
                        }}
                      >
                        {`${names[0].charAt(0)}${
                          names[1] ? names[1].charAt(0) : ""
                        }`}
                      </Button>
                    </Dropdown>
                    <div className="container_burger">
                      <Button
                        style={{
                          backgroundColor: "transparent",
                          border: 0,
                          padding: 0
                        }}
                        onClick={() => this.setState({ drawerVisible: true })}
                      >
                        <Icon
                          type="menu-fold"
                          style={{
                            fontSize: 22,
                            color: "white"
                          }}
                        />
                      </Button>
                      <Drawer
                        right
                        open={this.state.drawerVisible}
                        width={280}
                        className="drawer"
                        onChange={() => this.handleDrawer()}
                      >
                        <DrawerMenu
                          profile={profile}
                          signOut={signOut}
                          selectedDrawerItem={() => this.selectedDrawerItem()}
                        />
                      </Drawer>
                    </div>
                  </div>
                </Col>
              </Row>
            </Header>
          );
        }}
      </UserContext.Consumer>
    );
  }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/Components/Navigation/Navbar.js